<template>
    <footer class="footer container">
		<div class="wrapper" v-scroll-reveal> 
			<a class='navi-open' href='#' title='click'></a>
			<p>All Rights Reserved © 2020 Tim Ambi</p>
			<p>Experimental Coding</p>
			<br>
			
			<ul class='sns-list container'>
				<li><a href="mailto:timawbi@gmail.com" title='Email'><i class="fa fa-envelope"></i></a></li>
				<li><a href="https://www.fb.com/timambi" title='Facebook'><i class="fa fa-facebook-square"></i></a></li>
				<li><a href="https://www.linkedin.com/in/timambi/" title='LinkedIn'><i class="fa fa-linkedin"></i></a></li>
				<li><a href="#" title='Resume'><i class="fa fa-file"></i></a></li>
			</ul>


			

		</div>
		
	</footer>   
</template>

<script>
export default {
	name:"page-footer",

	
}
</script>